// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".p3GqK-AmountCell_root{justify-content:space-between;gap:1rem;font-size:1.1666666667rem;line-height:1.5rem}.p3GqK-AmountCell_root,.Ykl8t-AmountCell_value{display:flex;align-items:center}.Ykl8t-AmountCell_value{flex-shrink:0;gap:4px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "p3GqK-AmountCell_root",
	"value": "Ykl8t-AmountCell_value"
};
export default ___CSS_LOADER_EXPORT___;
